import React from 'react';
import ShippingForecast from "../../models/ShippingForecast";

export default function CartItemAgentStockMessage(props) {
  let {forecast = {}} = props;
  let {estimate} = forecast;

  if (!estimate)
    return null;

  let {shipperName} = estimate;

  return <div>
    <span className="fa fa-tachometer text-base"/>
    {' ' + shipperName + ': '}
    <ShippingForecastMessage forecast={forecast}/>
  </div>
}

function ShippingForecastMessage({forecast}) {
  let {estimate} = forecast;

  let shippingForecast = new ShippingForecast(forecast);

  let count = shippingForecast.stockCountForShipper(estimate.shipperId);
  if (count > 0) {
    return <span><strong>{count}</strong> in stock </span>
  } else if (estimate.willMake) {
    return <span> can ship </span>
  } else {
    return <span><strong>0</strong> in stock </span>
  }
}
